import { render, staticRenderFns } from "./CertificadoDeFinalizacion.vue?vue&type=template&id=1dd2f1ea&scoped=true"
import script from "./CertificadoDeFinalizacion.vue?vue&type=script&lang=js"
export * from "./CertificadoDeFinalizacion.vue?vue&type=script&lang=js"
import style0 from "./CertificadoDeFinalizacion.vue?vue&type=style&index=0&id=1dd2f1ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd2f1ea",
  null
  
)

export default component.exports